import { css, SerializedStyles } from '@emotion/react';

export const useStyles = (): SerializedStyles => css`
  flex-basis: 500px;
`;
